import { useTranslation } from 'next-i18next'
import React from 'react'
import { Head } from '../../component'

import { TrackPageViewed } from '../../integrations/monitoring'
import { CheckoutPage } from '../../model'

export const EducationIntroPage: CheckoutPage = () => {
  const { t } = useTranslation()

  const pageTitle = `${t('common:brandName')}`

  return (
    <>
      <Head title={pageTitle} />
      NUX
      <TrackPageViewed />
    </>
  )
}
